// extracted by mini-css-extract-plugin
export default {"tx":"_5f004a1aaa","line":"_876417ed3e"};